import { Preference } from '@libs/models';
import { api } from '../common.api';

export const preferenceApi = api.injectEndpoints({
  endpoints: (build) => ({
    getUserPreferences: build.query<Preference, void>({
      query: () => ({
        url: '/preferences',
        method: 'GET',
      }),
      providesTags: ['Preference'],
    }),
    updateUserPreferences: build.mutation<Preference, Partial<Preference>>({
      query: (preferences) => ({
        url: '/preferences',
        method: 'PATCH',
        body: preferences,
      }),
      invalidatesTags: ['Preference'],
    }),
  }),
});

export const { useGetUserPreferencesQuery, useUpdateUserPreferencesMutation } = preferenceApi;
